import React from 'react';
import { Text } from './UIKit/system';

function SectionSubtitle(props) {
  return <Text fontSize={24} {...props} />;
}

export default SectionSubtitle;
